import React from "react";
import "./App.css";
import Hero from "./components/hero/Hero";
import Projects from "./components/projects/Projects";
import Skills from "./components/skills/Skills";
import Contact from "./components/contact/Contact";

function App() {
  return (
    <div className="App">
      <div className="blue-polygon"></div>
      <div className="purple-polygon"></div>
      <div className="yellow-polygon"></div>
      <div className="green-polygon"></div>
      <div className="cyan-polygon"></div>
      <div className="pink-polygon"></div>
      <div className="orange-polygon"></div>
      <div className="violet-polygon"></div>
      <div className="content">
        <Hero />
        <Projects />
        <Skills />
        <Contact />
        <div>
          <footer className="footer">
            <p>&copy; 2025 Shivansh Shrivas. All rights reserved.</p>
            <p>Made using React</p>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default App;
